import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField, FormControlLabel, Checkbox, Popover } from '@material-ui/core';
import roadActions from '../../store/actions/roadActions';
import { HexColorPicker } from 'react-colorful';

const ContourValues = () => {
    const dispatch = useDispatch();
    const { contourValues, autoContourValues, contourColors, heatmap: heatmapInit, greyscale: greyscaleInit } = useSelector((state) => state.ProjectConfig);
    const [checked, setChecked] = React.useState(autoContourValues);

    // Heatmap and Greyscale state, initialized from ProjectConfig
    const [heatmap, setHeatmap] = useState(!!heatmapInit);
    const [greyscale, setGreyscale] = useState(!!greyscaleInit);

    const handleChange = (event) => {
        setChecked(event.target.checked);
        dispatch(roadActions.AddToCurrentState({ autoContourValues: event.target.checked }));
    };

    const newValue = useCallback(
        (event) => {
            const index = parseInt(event.target.id.replace('ContourValue', ''));
            const value = parseFloat(event.target.value);
            const newContourValues = [...contourValues];
            newContourValues[index] = value;
            dispatch(roadActions.AddToCurrentState({ contourValues: newContourValues }));
        },
        [contourValues, dispatch]
    );
    
    const [colors, setColors] = useState(contourColors);
    // Track which color picker is open (if any).
    const [anchorEl, setAnchorEl] = useState(null);
  // Track the index for which the popover is open
    const [activeIndex, setActiveIndex] = useState(null);

    // Handle opening the color picker popover
    const handleOpenColorPicker = (event, index) => {
        setAnchorEl(event.currentTarget);
        setActiveIndex(index);
    };

    // Handle color change
    const handleColorChange = (index, newColor) => {
        const updatedColors = [...colors];
        updatedColors[index] = newColor;
        setColors(updatedColors);
        dispatch(roadActions.AddToCurrentState({ contourColors: updatedColors }));
    };

    // Handle closing the popover
    const handleCloseColorPicker = () => {
        setAnchorEl(null);
        setActiveIndex(null);
    };

    // Determine if the popover is open
    const popoverOpen = Boolean(anchorEl);

    const indices = Array.from({ length: 7 }, (_, index) => index);

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>            
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <label htmlFor="contourValues" style={{ marginRight: '1rem' }}>
                    Contour Values:
                </label>
                <>
                    {indices.map((index) => {

                        return (
                        <div key={index} style={{ marginBottom: '1rem', position: 'relative' }}>
                            <TextField
                            disabled={checked}
                            type="number"
                            name="contourValue"
                            value={contourValues[index]}
                            id={`ContourValue${index}`}
                            step="0.01"
                            onChange={newValue}
                            style={{ width: '45px', marginRight: '1rem' }}
                            className="Contour-Input"
                            />
                            {/* Color square that opens the popover on click */}
                            <div
                            onClick={(e) => handleOpenColorPicker(e, index)}
                            style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: colors[index],
                                cursor: 'pointer',
                                display: 'inline-block',
                                verticalAlign: 'middle',
                                marginRight: '1rem',
                                border: '1px solid #ccc'
                            }}
                            />
                        </div>
                        );
                    })}
                    {/* Popover containing the HexColorPicker */}
                    <Popover
                        open={popoverOpen}
                        anchorEl={anchorEl}
                        onClose={handleCloseColorPicker}
                        anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                        }}
                        transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                        }}
                    >
                        {activeIndex !== null && (
                        <div style={{ padding: '1rem' }}>
                            <HexColorPicker
                            color={colors[activeIndex]}
                            onChange={(newColor) => handleColorChange(activeIndex, newColor)}
                            />
                        </div>
                        )}
                    </Popover>
                </>
            </div>
            {/* Heatmap and Greyscale checkboxes */}
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.5rem' }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={heatmap}
                            onChange={(_, checked) => {
                                setHeatmap(checked);
                                dispatch(roadActions.AddToCurrentState({ heatmap: checked }));
                                if (!checked) {
                                    setGreyscale(false);
                                    dispatch(roadActions.AddToCurrentState({ greyscale: false }));
                                }
                            }}
                            name="heatmap"
                            color="primary"
                        />
                    }
                    label="Heatmap"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={greyscale}
                            onChange={(_, checked) => {
                                setGreyscale(checked);
                                dispatch(roadActions.AddToCurrentState({ greyscale: checked }));
                            }}
                            name="greyscale"
                            color="primary"
                            disabled={!heatmap}
                        />
                    }
                    label="Greyscale"
                />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={handleChange}
                            name="autoContourValues"
                            color="primary"
                        />
                    }
                    label="Auto Contour Values"
                />
            </div>
        </div>
    );
};

export default ContourValues;